import { IGraphQl } from 'client/graphQueries/IGraphQl'
import { DraftCommonInterface } from 'client/Interfaces/Draft/v1/DraftInterface'
import { IInvoiceEventShared } from 'client/Interfaces/Invoice/InvoiceEventsInterface'

export enum DeliverynoteType {
  draft = 'deliverynoteDraft',
  approved = 'deliverynote',
}

export enum DeliverynoteStatus {
  DRAFT = 'draft',
  CREATED = 'created',
  SENT = 'sent',
  DELETED = 'deleted',
}

export interface DeliverynoteDraftInterface extends DraftCommonInterface {
  id: number
  receiptNumber?: string
  deliverynoteNumber?: string
  documentType?: DeliverynoteType.draft | DeliverynoteType.approved
}

export interface DeliverynoteInterface extends DeliverynoteDraftInterface {
  revisionId: number
  deliverynoteNumber: string
  documentType: DeliverynoteType.approved
  status: { status: DeliverynoteStatus; events: IInvoiceEventShared[] }
}

export type DeliverynoteListItemInterface = IGraphQl<DeliverynoteInterface, DeliverynoteType.approved>

export type DeliverynoteDraftListItemInterface = IGraphQl<DeliverynoteDraftInterface, DeliverynoteType.draft>
